import request from '@/utils/request'

// 查询商品分类信息列表分页
export function fetchList(query) {
    return request({
        url: '/upkeep/service/page',
        method: 'get',
        params: query,
    })
}
// 查询商品分类信息列表不分页
export function categoryList(query) {
    return request({
        url: '/upkeep/complaint/list',
        method: 'get',
        params: query,
    })
}
// 查询商品分类详细
export function getObj(id) {
    return request({
        url: 'upkeep/service/detail?id=' + id,
        method: 'get',
    })
}
// 新增商品分类
export function addObj(data) {
    return request({
        url: '/upkeep/service/add',
        method: 'post',
        data: data,
    })
}

// 修改商品分类
export function putObj(data) {
    return request({
        url: '/upkeep/service/edit',
        method: 'post',
        data: data,
    })
}
// 删除商品分类
export function delObj(data) {
    return request({
        url: '/upkeep/service/delete',
        method: 'post',
        data: data,
    })
}

// 更改状态
export function statusObj(data) {
    return request({
        url: '/upkeep/service/status',
        method: 'post',
        data: data,
    })
}